import React from "react";

import { Wrapper, Bold, Header1, Page } from "app/NativeComponents/common";
import { InlineButton, OnboardingWrapper } from "app/NativeComponents/snippets";
import { displayIntercom } from "app/NativeActions";

const Canceled = () => (
  <Page
    metaTitle={"Your account has been canceled - DealMachine"}
    responsive_design={true}
  >
    <OnboardingWrapper>
      <Wrapper style={{ padding: 25 }}>
        <Header1 style={{ textAlign: "center" }}>
          <Bold>Your account has been canceled.</Bold>
        </Header1>
      </Wrapper>
      <Wrapper
        style={{
          padding: 25,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <InlineButton id="intercom_button" onPress={() => displayIntercom()}>
          Talk To Support
        </InlineButton>
      </Wrapper>
    </OnboardingWrapper>
  </Page>
);

export default Canceled;
